import { render, staticRenderFns } from "./DeleteGroupInvestors.vue?vue&type=template&id=f99206a8&scoped=true"
import script from "./DeleteGroupInvestors.vue?vue&type=script&lang=js"
export * from "./DeleteGroupInvestors.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroupInvestors.vue?vue&type=style&index=0&id=f99206a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99206a8",
  null
  
)

export default component.exports